/** Mecánica pura: recolectadas + timer 20s (límite principal). Sin cámara, DOM ni Three.js. */
export class GameEngine {
  constructor({ durationMs = 20_000, targetScore = 50, maxHitsPerSecond = 10 } = {}) {
    if (!(durationMs > 0 && targetScore > 0 && maxHitsPerSecond > 0)) {
      throw new Error('Game settings must be positive');
    }
    this.settings = { durationMs, targetScore, maxHitsPerSecond };
    this.reset();
  }

  reset() {
    this.status = 'ready';
    this.score = 0;
    this.elapsedMs = 0;
    this.lastHitAt = -Infinity;
    this.result = null;
    this.combo = 0;
    return this.snapshot();
  }

  start() {
    if (this.status !== 'ready') return false;
    this.status = 'playing';
    return true;
  }

  pause() {
    if (this.status !== 'playing') return false;
    this.status = 'paused';
    return true;
  }

  resume() {
    if (this.status !== 'paused') return false;
    this.status = 'playing';
    return true;
  }

  tick(deltaMs) {
    if (!Number.isFinite(deltaMs) || deltaMs < 0) {
      // Tolerar frames anómalos del rAF (background / clock skew).
      return this.snapshot();
    }
    if (this.status !== 'playing') return this.snapshot();
    this.elapsedMs = Math.min(this.settings.durationMs, this.elapsedMs + deltaMs);
    if (this.elapsedMs >= this.settings.durationMs) {
      // El reloj cierra la ronda; la meta de recolectadas solo clasifica victoria/derrota.
      this.finish(this.score >= this.settings.targetScore ? 'won' : 'time_up');
    }
    return this.snapshot();
  }

  hit() {
    if (this.status !== 'playing') return false;
    const minHitGap = 1000 / this.settings.maxHitsPerSecond;
    if (this.elapsedMs - this.lastHitAt < minHitGap) return false;
    this.lastHitAt = this.elapsedMs;
    this.combo += 1;
    // 1 orbe = 1 punto (HUD X/50). El combo es feedback del personaje, no suma extra.
    this.score += 1;
    return true;
  }

  missGap() {
    this.combo = 0;
  }

  finish(reason) {
    if (this.status === 'finished') return false;
    this.status = 'finished';
    this.result = reason;
    return true;
  }

  snapshot() {
    return Object.freeze({
      status: this.status,
      score: this.score,
      targetScore: this.settings.targetScore,
      combo: this.combo,
      elapsedMs: Math.round(this.elapsedMs),
      remainingMs: Math.max(0, Math.round(this.settings.durationMs - this.elapsedMs)),
      result: this.result,
    });
  }
}
